"use client";
import Image from "next/image";
import star from "@/public/images/starBlack.svg";
import verifyCheck from "@/public/images/verifyCheck.svg";
import user from "@/public/images/user.svg";
import rightCheck from "@/public/images/rigthCheck.svg";
import aboutus from "@/public/images/aboutus.jpg";
import BookConsultation from "@/components/shared/BookConsultation";
import { useTranslate } from "@/components/base/providers/TranslateProv";
import FreeConsultation from "./components/freeConsultation/FreeConsultation";
import OtherServices from "./components/other services/OtherServices";
import PaidConsultation from "./components/Paid Consultation/PaidConsultation";

const translations = {
  ar: {
    title: "حجز استشاره معنا للرد علي جميع الاسئله الخاص بك",
    description:
      "احصل على إجابات فورية وشاملة لكل أسئلتك حول الجامعات الخاصة والاهلية وذات طابع في مصر ! احجز استشارتك الآن وانطلق في رحلة تحقيق أهدافك التعليمية بكل ثقة ويقين.",
    reviewRating: "تقيم الاستشارة",
    stars: "+5/5 نجوم",
    experience: "خبره في المجال",
    years: "+7 سنوات",
    consultations: "عدد طلابات الاستشارة",
    peopleServed: "+5000 شخص",
    feature1: "متابعه معك",
    feature2: "رد علي جميع استفسارتك",
    feature3: "ترشيح ليك المناسب لك",
    paidConsultation: "استشاره مدفوعه ( ساعة )",
    freeConsultation: "استشاره مجانية ( رساله فقط )",
    otherServices: "خدمات مقدمة آخرى",
  },
  en: {
    title: "Book a consultation with us to answer all your questions",
    description:
      "Get immediate and comprehensive answers to all your questions about private and national universities in Egypt! Book your consultation now and embark on your educational journey with confidence and certainty.",
    reviewRating: "Consultation Rating",
    stars: "+5/5 stars",
    experience: "Field Experience",
    years: "+7 years",
    consultations: "Number of Consultation Requests",
    peopleServed: "+5000 people",
    feature1: "Follow-up with you",
    feature2: "Answer all your inquiries",
    feature3: "Recommend what's suitable for you",
    paidConsultation: "Paid Consultation (1 hour)",
    freeConsultation: "Free Consultation (message only)",
    otherServices: "Other Services Offered",
  },
};

const Index = () => {
  const { locale } = useTranslate();
  const lang = locale as "ar" | "en";
  const t = translations[lang];
  return (
    <div className="bg-[#F8F9FA] py-[50px]">
      <div className="container bg-white border border-[#EBEBEB] rounded-[24px] p-5 grid grid-cols-1 md:grid-cols-2 gap-5">
        <div className="flex flex-col gap-5">
          <Image src={aboutus} alt="aboutus" className="max-h-[370px]" />
          <div className="grid grid-cols-3 gap-3">
            <div className="bg-[#F8F9FA] rounded-[10px] p-2 flex flex-col items-center justify-center gap-3">
              <Image src={star} alt="calendar" />
              <p className="text-14 text-darkText text-center">
                {t.reviewRating}
              </p>
              <p className="text-14 text-[#ACB5BB] font-[600]">{t.stars}</p>
            </div>
            <div className="bg-[#F8F9FA] rounded-[10px] p-2 flex flex-col items-center justify-center gap-3">
              <Image src={verifyCheck} alt="calendar" />
              <p className="text-14 text-darkText text-center">
                {t.experience}
              </p>
              <p className="text-14 text-[#ACB5BB] font-[600]">{t.years}</p>
            </div>
            <div className="bg-[#F8F9FA] rounded-[10px] p-2 flex flex-col items-center justify-center gap-3">
              <Image src={user} alt="calendar" />
              <p className="text-14 text-darkText text-center">
                {t.consultations}
              </p>
              <p className="text-14 text-[#ACB5BB] font-[600]">
                {t.peopleServed}
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-5">
          <p className="text-36 text-darkText font-[600] max-w-[632px]">
            {t.title}
          </p>
          <p className="text-20 text-descriptionText max-w-[632px]">
            {t.description}
          </p>
          <div className="flex flex-col gap-3">
            <p className="text-18 text-darkText flex items-center gap-3">
              <Image src={rightCheck} alt="right" /> {t.feature1}
            </p>
            <p className="text-18 text-darkText flex items-center gap-3">
              <Image src={rightCheck} alt="right" /> {t.feature2}
            </p>
            <p className="text-18 text-darkText flex items-center gap-3">
              <Image src={rightCheck} alt="right" /> {t.feature3}
            </p>
          </div>
          <PaidConsultation>
            <span className="bg-primaryColor py-3 rounded-[10px] text-20 text-white flex items-center justify-center w-full cursor-pointer">
              {t.paidConsultation}
            </span>
          </PaidConsultation>
          <div className="flex gap-5">
            <FreeConsultation>
              <button
                type="button"
                role="button"
                className="border w-full border-primaryColor py-3 rounded-[10px] text-20 text-primaryColor flex items-center justify-center grow"
              >
                {t.freeConsultation}
              </button>
            </FreeConsultation>

            <OtherServices>
              <button
                type="button"
                role="button"
                className="border w-full border-primaryColor py-3 rounded-[10px] text-20 text-primaryColor flex items-center justify-center grow"
              >
                {t.otherServices}
              </button>
            </OtherServices>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
